import { render } from "./DataVisualization.vue?vue&type=template&id=79f34c6e"
import script from "./DataVisualization.vue?vue&type=script&lang=js"
export * from "./DataVisualization.vue?vue&type=script&lang=js"

import exportComponent from "/home/nucleares/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__